import type { CustomDetector } from "i18next-browser-languagedetector"

export const i18nSavedLanguageStorageKey = "i18nLngSaved"
const i18nSavedLanguageDetector: CustomDetector = {
  name: "savedLanguageDetector",
  lookup: () => {
    const savedLanguage = window.localStorage.getItem(i18nSavedLanguageStorageKey)
    if (savedLanguage) return savedLanguage
  }
}

export default i18nSavedLanguageDetector
